import React from 'react';
import './tank.css'; // Ensure this path is correct!

export default function Tank({ label, level, type }) {
  const isNull = level === null;
  
  // Water = Blue, Diesel = Amber, Missing = Silver
  const activeColor = isNull ? '#cbd5e1' : (type === 'water' ? '#0ea5e9' : '#f59e0b');

  return (
    <div className="scada-tank-wrapper" style={{ opacity: isNull ? 0.6 : 1 }}>
      {/* Percentage outside - Visible at all times */}
      <div className="tank-percentage-outer" style={{ color: activeColor }}>
        {isNull ? 'N/A' : `${level}%`}
      </div>

      <div className="tank-body" style={{ borderColor: activeColor }}>
        {/* Reflection stays on top for a glass effect */}
        <div className="tank-reflection"></div>
        
        <div className="tank-liquid" style={{ 
            height: isNull ? '0%' : `${level}%`, 
            backgroundColor: activeColor,
            boxShadow: isNull ? 'none' : `0 0 15px ${activeColor}55`
        }}>
          {/* Wave only shows if tank is connected and has some fluid */}
          {!isNull && level > 0 && <div className="liquid-wave"></div>}
        </div>
      </div>

      <div className="tank-name">{label}</div>
    </div>
  );
}